export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6410.d5e09df3.jpg";